module.exports = __webpack_public_path__ + "media/images/home/cash@2x-1fdbfadb1b2b7716542abc834fc3b97e.png";